module.exports = __webpack_public_path__ + "resources/img/item2.a4fe61b9.svg";